import { MainLayoutComponent } from '@components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { LanguagesComponent } from './languages/languages.component';
import { LanguagesListComponent } from './languages/languages-list/languages-list.component';
import { LanguagesCrudComponent } from './languages/languages-crud/languages-crud.component';

export const languagesRoutes: Routes = [
    {
        path: 'admin/languages',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'USER_MANAGEMENT',
                redirectTo: '/'
            }
        },
        children: [
            {
                path: '',
                component: LanguagesComponent,
                children: [
                    {
                        path: 'list',
                        component: LanguagesListComponent
                    },
                    {
                        path: 'crud',
                        component: LanguagesCrudComponent
                    }
                ]
            },

        ]
    }
];
